export default "__VITE_ASSET__B$ZaRUi0__"